import React from 'react'
import { connect } from 'react-redux'
import styles from './Header.module.css';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { patientActions } from '_actions'


class PatientCareCenterHomeHeader extends React.Component {

    constructor() {
        super();
        this.openMap = this.openMap.bind(this);
        this.handlePatientNotesChange = this.handlePatientNotesChange.bind(this);
        this.saveNotes = this.saveNotes.bind(this);
        this.state = {
            patientNotes: "",
            changingTimeout: 0,
            hasChanges: false
        };
    }

    componentDidMount() {
        this.setState((state) => {
            return { patientNotes: this.props.patient.notes ? this.props.patient.notes.trim() : '' };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient.id !== prevProps.patient.id) {
            this.setState((state) => {
                return { patientNotes: this.props.patient.notes ? this.props.patient.notes.trim() : '', hasChanges: false };
            })
        }
    }


    handlePatientNotesChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        this.setState({
            patientNotes: event.target.value,
            hasChanges: true,
            changingTimeout: setTimeout(() => this.saveNotes(), 2000)
        });
    }

    saveNotes() {
        if (this.state.hasChanges) {
            this.props.updatePatientNotes(this.props.patient.id, this.state.patientNotes);
            this.setState({ hasChanges: false });
        }
    }

    openMap(event) {
        var addr = this.props.patient.addr1 + ' ' + this.props.patient.addr2 + ' ' + this.props.patient.city + ', ' + this.props.patient.state + ' ' + this.props.patient.zip;
        addr = encodeURIComponent(addr);
        window.open('https://www.google.com/maps/search/?api=1&query=' + addr);
    }


    render() {
        var patient = this.props.patient.firstName + ' ' + this.props.patient.lastName + ' (SYS' + this.props.patient.id + ')';
        return (
            <div className={styles.header}>
                <div className={styles.header_left}>
                    <div>
                        <span title={patient} className={styles.header_name}>{this.props.patient.firstName}</span>
                        <span title={patient} className={styles.header_name}>{this.props.patient.lastName}</span>
                        <span title={patient} className={styles.header_sys}>{'(SYS' + this.props.patient.id + ')'}</span>

                    </div>
                    <div title={patient} className={styles.header_image}>
                        <FontAwesomeIcon icon={faUserCircle} transform="grow-8" />

                    </div>
                </div>
                <div className={styles.header_middle}>
                    <span className={styles.demographics}>
                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}>DOB:</span>
                            <span className={styles.demographics_row_data}>{this.props.patient.dob}</span>
                        </span>

                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}>Cell:</span>
                            <span className={styles.demographics_row_data}>{this.props.patient.cell}</span>
                        </span>

                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}>Home:</span>
                            <span className={styles.demographics_row_data}>{this.props.patient.home}</span>
                        </span>

                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}>
                                Addr:
                                <span className={styles.map_pin} onClick={this.openMap}>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                                </span>
                            </span>
                            <span className={styles.demographics_row_data}>{this.props.patient.addr1}</span>
                        </span>

                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}></span>
                            <span className={styles.demographics_row_data}>{this.props.patient.addr2}</span>
                        </span>

                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}></span>
                            <span className={styles.demographics_row_data}>{this.props.patient.city + ', ' + this.props.patient.state + ' ' + this.props.patient.zip}</span>
                        </span>

                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}>eMail:</span>
                            <span className={styles.demographics_row_data}>{this.props.patient.email}</span>
                        </span>
                        <span className={styles.demographics_row}>
                            <span className={styles.demographics_row_header}>Gender:</span>
                            <span className={styles.demographics_row_data}>{this.props.patGender}</span>
                        </span>

                    </span>
                </div>
                <div className={styles.header_right}>
                    <div className={styles.notes_header}>Notes / Info / Hobbies</div>
                    <div className={styles.notes_input}>
                        <textarea name="patientNotes" type="text" className={styles.patient_notes} rows="6" value={this.state.patientNotes} onChange={this.handlePatientNotesChange} onBlur={this.saveNotes} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let patient = state.entities.patients[state.ui.patients.selectedPtno]
    let patGender = patient.gender === 'M' ? 'Male' : patient.gender === 'F' ? 'Female' : patient.gender === 'A' ? 'Ambiguous' : 'Unknown';

    return {
        patient: patient,
        ptno: state.ui.patients.selectedPtno,
        patGender
    };
}

function mapDispatchToProps(dispatch) {


    return {
        updatePatientNotes: bindActionCreators(patientActions.updatePatientNotes, dispatch)
    };
}


const connectedPatientCareCenterHomeHeader = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterHomeHeader);
export { connectedPatientCareCenterHomeHeader as PatientCareCenterHomeHeader };
